<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  <h3 class="modal-title">Edit Status  </h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body modal-body-height">
  <div class="row">
    <div class="col-lg-12">
      <div class="overflow-x" style="width: 100%;">
        <div class="row">
          <div class="col-lg-12" *ngIf="regulationDetails && regulationDetails.linkedIds">
            <div class="link-div mb-2 cursor-pointer" (click)="getLinkedInfo(linkedId)"
              *ngFor="let linkedId of regulationDetails.linkedIds.split('|')">
              <span class="link-id">{{linkedId}}</span>
            </div>
          </div>
          <div class="col-lg-6 edit_status_changeViewer_group mt-2">
            <div class="control-label fw">Title</div>
            <mat-form-field class="disableText w-100">
              <textarea matInput class="text-area-css" disabled [(ngModel)]="regulationDetails.title"
                cdkTextareaAutosize></textarea>
            </mat-form-field>
          </div>
          <div class="col-lg-6 mt-2">
            <label class="control-label fw">Type</label>
            <input type="text" [(ngModel)]="regulationDetails.type" disabled class="form-control form-control-sm" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="control-label fw">Status</label>
            <select class="form-control form-control-sm" [attr.disabled]="isDisabled ? 'disabled' : null"
              [(ngModel)]="regulationDetails.status">
              <option *ngFor="let item of closeStatusList" [value]="item.id">
                {{item.title}}
              </option> 
            </select>
          </div>
          <div class="col-lg-6 edit_status_changeViewer_group">
            <div class="control-label fw">Comment</div>
            <mat-form-field class="textarea_field w-100">
              <textarea matInput class="text-area-css" *ngIf="!isDisabled" [(ngModel)]="regulationDetails.comment"
                cdkTextareaAutosize></textarea>
              <textarea matInput class="text-area-css" *ngIf="isDisabled" disabled
                [(ngModel)]="regulationDetails.comment" cdkTextareaAutosize></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="control-label fw" *ngIf="regulationDetails && regulationDetails.id === 0">Updated
              By</label>
            <label class="control-label fw" *ngIf="regulationDetails && regulationDetails.id > 0">Last Updated
              By</label>
            <input type="text" value="{{ userName ? userName : ''}}" disabled class="form-control form-control-sm" />
          </div>
          <div class="col-lg-6">
            <div class="control-label fw">Division</div>
            <div *ngIf="savedJuridiction && savedJuridiction.length > 0">
              <span *ngFor="let juris of savedJuridiction" class="mat-chip mat-standard-chip mb-2">{{juris}}</span>
            </div>
            <ng-select *ngIf="searchedJuris.length > 0 && !isDisabled && filterType !== 'Actioned'" class="regulation-dialog" [items]="searchedJuris"
              bindLabel="name" [multiple]="true" [(ngModel)]="selectedJuris" (change)="onChange()">
            </ng-select>
            <ng-select *ngIf="searchedJuris.length > 0 && !isDisabled && filterType === 'Actioned'" disabled class="regulation-dialog" [items]="searchedJuris"
              bindLabel="name" [multiple]="true" [(ngModel)]="selectedJuris" (change)="onChange()">
            </ng-select>
            <ng-select *ngIf="searchedJuris.length > 0 && isDisabled" disabled class="regulation-dialog"
              [items]="searchedJuris" bindLabel="name" [multiple]="true" [(ngModel)]="selectedJuris">
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 mt-2"
      *ngIf="regulationDetails.id === 0 && filterType !== 'Actioned' && filterType !== 'Current Actions'">
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <div class="control-label fw">Keyword Search</div>
            <input type="text" class="form-control form-control-sm" (keyup)="onEnterSearchKeys($event)"
              [(ngModel)]="searchText" />
          </div>
        </div>
        <div class="row col-lg-6">
          <!-- <span class="text-primary ml-1 fw" >Upload Evidence - Assessment</span> -->
          <div class="col-lg-12 cursor-pointer" (click)="uploadEvidenceAssessment()">
            <i class="fa fa-upload"></i>
            <span class="text-primary ml-1 fw">Upload Evidence - Assessment
              <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </span>
            <input id="uploadEviAssessment" (change)="handleFileInput($event.target.files)" type="file" multiple
              style="display: none" #myFileInput/><br />
          </div>
          <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
            <div *ngIf="isFileExist">
              <ng-container *ngFor="let docs of impactAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === '1'">
                  <span class="fa fa-trash delete-docs pull-right delete-icon" 
                    (click)="openDeleteModel(docs.id, docs.jurisdictionId,'Assessment',docs.fileExtension,docs.fileName,docs.fileUrl)"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment',docs.fileUrl)">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-lg-6" *ngIf="similarResult.closedIds && similarResult.closedIds.length > 0">
          <div class="control-label fw">
            <input type="checkbox" name="All" *ngIf="!isSelectClosed" (change)="selectAllClosed($event)" />
            <input type="checkbox" name="All" checked *ngIf="isSelectClosed" (change)="selectAllClosed($event)" />
            Closed
          </div>
          <div class="overflow-div-2 pt-2">
            <div *ngFor="let rt of similarResult.closedIds"
              class="highlight-text-blue oveflow-div rp-highlight item-text">
              <span (click)="openEditPopup(rt)">{{rt}}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6" *ngIf="similarResult.impactAssessmentIds && similarResult.impactAssessmentIds.length > 0">
          <div class="control-label fw">Impact Assessment</div>
          <div class="overflow-div-2 pt-2">
            <div *ngFor="let rt of similarResult.impactAssessmentIds"
              class="highlight-text-blue oveflow-div rp-highlight item-text">
              <span (click)="openAssessmentPopup(rt.id)">{{rt.updatedDbId}}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-12 text-left" *ngIf="isTableLoaded">
          <div class="text-blue">
            {{endIndex}} out of {{totalCount}}
          </div>
        </div>
        <div class="col-lg-12">
          <div class="table-responsive box-shadow table-cont body-style">
            <table class="table table-fixed table-hover mb-0">
              <thead>
                <tr>
                  <th class="text-center mx-width-1pr">
                    <input type="checkbox" name="All" *ngIf="!isSelectAll" (change)="selectAllItem($event)" />
                    <input type="checkbox" name="All" checked *ngIf="isSelectAll" (change)="selectAllItem($event)" />
                  </th>
                  <th class="col-lg-2 mx-width-12pr" (click)="sortItem('id')">Id
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'id' && !filters.IsDesc),
            'fa-sort-amount-desc': (filters.SortKey === 'id' && filters.IsDesc) }" aria-hidden="true">
                    </i>
                  </th>
                  <th class="col-lg-2 mx-width-12pr" (click)="sortItem('regulator')">Regulator
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'regulator' && !filters.IsDesc),
            'fa-sort-amount-desc': (filters.SortKey === 'regulator' && filters.IsDesc) }" aria-hidden="true">
                    </i>
                  </th>
                  <th class="col-lg-2 mx-width-12pr" (click)="sortItem('date')">Date
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'date' && !filters.IsDesc),
            'fa-sort-amount-desc': (filters.SortKey === 'date' && filters.IsDesc) }" aria-hidden="true">
                    </i>
                  </th>
                  <th class="col-lg-2 mx-width-16pr" (click)="sortItem('pubType')">Pub Type
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'pubType' && !filters.IsDesc),
            'fa-sort-amount-desc': (filters.SortKey === 'pubType' && filters.IsDesc) }" aria-hidden="true">
                    </i>
                  </th>
                  <th class="col-lg-3 max-width-45pr" (click)="sortItem('title')">Title
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'title' && !filters.IsDesc),
            'fa-sort-amount-desc': (filters.SortKey === 'title' && filters.IsDesc) }" aria-hidden="true">
                    </i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!isTableLoaded">
                  <td> <i class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i></td>
                </tr>
                <tr *ngIf="isTableLoaded && linkedUpdates && linkedUpdates.length === 0">
                  <td>No Data</td>
                </tr>
              </tbody>
              <tbody *ngIf="linkedUpdates && linkedUpdates.length > 0" style="height: 350px;">
                <tr *ngFor="let item of linkedUpdates">
                  <td class="mx-width-1pr text-center" scope="row">
                    <input type="checkbox" name="All" *ngIf="!checkSelectedItem(item.id)" (change)="selectItem($event, item.id)" />
                    <input type="checkbox" name="All" checked *ngIf="checkSelectedItem(item.id)" (change)="selectItem($event, item.id)" />
                  </td>
                  <td class="col-lg-2 mx-width-12pr">{{item.id}}</td>
                  <td class="col-lg-2 mx-width-12pr" scope="row">{{item.regulator}}</td>
                  <td class="col-lg-2 mx-width-12pr" scope="row">{{item.date |
                    date:'dd-MMM-yyyy'}}</td>
                  <td class="col-lg-2 mx-width-16pr tabel-td-scroll" scope="row">{{item.pubType}}</td>
                  <td class="col-lg-3 max-width-45pr tabel-td-scroll" scope="row">{{item.title}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 mt-2"
      *ngIf="regulationDetails.id !== 0 &&(filterType === 'Actioned' || filterType === 'Current Actions')">
      <div class="row">
        <div class="row col-lg-12">
          <div *ngIf="this.filterType !== 'Current Actions'" class="col-lg-12 cursor-pointer" (click)="uploadEvidenceAssessment()" >
            <i class="fa fa-upload"></i>
            <span class="text-primary ml-1 fw">Upload Evidence - Assessment
              <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </span>
            <input id="uploadEviAssessment" (change)="handleFileInput($event.target.files)" type="file" multiple
              style="display: none" /><br />
          </div>
          <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
            <div *ngIf="isFileExist">
              <ng-container *ngFor="let docs of impactAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === '1'">
                  <span class="fa fa-trash delete-docs pull-right delete-icon" *ngIf="this.filterType !== 'Current Actions'"
                    (click)="openDeleteModel(docs.id, docs.jurisdictionId,'Assessment',docs.fileExtension,docs.fileName,docs.fileUrl)"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment',docs.fileUrl)">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default" [attr.disabled]="isDisabled ? 'disabled' : null"
    *ngIf="filterType === 'Actioned'"
    (click)="addImpactAssessment(regulationDetails.regulationId)">Start Impact Assessment
    <i *ngIf="isMovedToIA" class="fa fa-circle-o-notch fa-spin"
      style="font-size: .875rem; line-height: 1.5;"></i></button>
  <button class="btn btn-sm btn-default pull-right" [attr.disabled]="isDisabled ? 'disabled' : null"
    (click)="closeDialog()" cdkFocusInitial>Update</button>
  <button class="btn btn-sm btn-default pull-right" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm btn-danger pull-right" *ngIf="filterType === 'Actioned'" [attr.disabled]="isDelete ? 'disabled' : null"
    (click)="openDeleteDialog()">Delete</button>
</div>
